<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { faUser } from '@fortawesome/free-solid-svg-icons'
    dayjs.locale('pt-br')

    let show = false

    let grid: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: any[] = await window.api.events.persons.Birthdays(from, to)
        //data = await window.api.utils.utils.assignPersonsFromObject(data)
        console.log('relat.data', data)
        grid = new GridClass()
        grid.title = 'Aniversariantes'
        //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
        grid.cols.push(new GridCol({ content: 'Cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
        grid.cols.push(new GridCol({ content: 'Nascimento', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Aniversário', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        data.sort((a, b) => +new Date(a.birthday) - +new Date(b.birthday))
        for (const item of data) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.name })
            line.slots.push({ content: item.phone })
            line.slots.push({ content: item.email })
            line.slots.push({ content: item.born })
            line.slots.push({ content: item.birthday })
            line.slots.push({ content: [new GridButton({ callback: () => window.person('show', item.personId), icon: faUser })] })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        show = false
    }

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
